import type { CollectionVariantDetailsModel } from "@/features/collections/api/models/CollectionVariantDetailsModel";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const useCollectionVariantDetails = (collectionId: string, variantId: string | undefined) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["collectionVariantDetails", collectionId, variantId],
		enabled: !!variantId,
		queryFn: () => http<CollectionVariantDetailsModel>({
			method: "GET",
			url: `/collection/${collectionId}/variant/${variantId}`
		})
	});
};
